export const sysop = {
    "apiLog": {
        "apiLog01": "查詢日期",
        "apiLog02": "狀態碼",
        "apiLog03": "發送位址",
        "apiLog04": "請求路徑",
        "apiLog05": "日誌時間"
    },
    "certificateBinding": {
        "certificateBinding01": "使用者",
        "certificateBinding02": "憑證",
        "certificateBinding03": "啟用狀況",
        "certificateBinding04": "最後異動時間",
        "certificateBinding05": "停用",
        "certificateBinding06": "啟用",
        "certificateBinding07": "憑證綁定-新增",
        "certificateBinding08": "憑證綁定-修改",
    },
    "empUser": {
        "empUser01": "帳號",
        "empUser02": "姓名",
        "empUser03": "電子郵件",
        "empUser04": "密碼",
        "empUser05": "確認密碼",
        "empUser06": "角色列表",
        "empUser07": "'確認密碼' 和 '密碼' 不相符",
        "empUser08": "使用者-新增",
        "empUser09": "使用者-修改"
    },
    "dimRole": {
        "dimRole01": "角色代碼",
        "dimRole02": "角色名稱",
        "dimRole03": "權限列表",
        "dimRole04": "角色-新增",
        "dimRole05": "角色-修改"
    },
    "accRightMan": {
        "accRightMan01": "載入default設定",
        "accRightMan02": "帳號限制",
        "accRightMan03": "最短長度:",
        "accRightMan04": "至少個字元",
        "accRightMan05": "密碼限制",
        "accRightMan06": "不可與帳號或使用者名稱相同",
        "accRightMan07": "密碼必須為文數字混合(英文大、小寫、數字、特殊符號四種須符合三種)",
        "accRightMan08": "不可含空白或特殊字元，只能用文字 A-Z 或數字 1-9 組成",
        "accRightMan09": "至少含",
        "accRightMan10": "個特殊字元",
        "accRightMan11": "相鄰二字元不可相同",
        "accRightMan12": "相鄰三字元不可為連續升冪或降冪",
        "accRightMan13": "不可與最近",
        "accRightMan14": "次內重複",
        "accRightMan15": "帳號關閉原則",
        "accRightMan16": "停用",
        "accRightMan17": "啟用",
        "accRightMan18": "同一天密碼連續錯誤",
        "accRightMan19": "次，帳號鎖定",
        "accRightMan20": "分鐘",
        "accRightMan21": "同一天密碼非連續錯誤",
    },
    "dimRight": {
        "dimRight01": "權限代碼",
        "dimRight02": "權限名稱",
        "dimRight03": "功能列表",
        "dimRight04": "權利-新增",
        "dimRight05": "權利-修改"
    },
    "setFunction": {
        "setFunction01": "新增類別",
        "setFunction02": "設定排序",
        "setFunction03": "功能類別",
        "setFunction04": "功能代碼",
        "setFunction05": "功能名稱",
        "setFunction06": "排序",
        "setFunction07": "網址",
        "setFunction08": "功能-新增",
        "setFunction09": "功能-修改"
    },
    "empAgent": {
        "empAgent01": "代理帳號",
        "empAgent02": "代理期間",
        "empAgent03": "設定代理者帳號",
        "empAgent04": "代理開始日期",
        "empAgent05": "代理結束日期",
        "empAgent06": "代理人-新增"
    },
    "empOrg": {
        "empOrg01": "組織名稱",
        "empOrg02": "組織代碼",
        "empOrg03": "上層組織",
        "empOrg04": "所屬使用者",
        "empOrg05": "組織-新增",
        "empOrg06": "組織-修改",
    },
    "setParam": {
        "setParam01": "修改參數",
        "setParam02": "參數代碼",
        "setParam03": "參數",
        "setParam04": "說明",
        "setParam05": "新增參數類別",
        "setParam06": "新增參數",
        "setParam07": "修改參數類別",
        "setParam08": "參數類別代碼",
        "setParam09": "參數類別",
        "setParam10": "功能類別代碼必填",
        "setParam11": "功能名稱必填",
        "setParam12": "流程說明",
        "setParam13": "參數數值",
        "setParam14": "系統參數-參數新增",
        "setParam15": "系統參數-參數修改",
        "setParam16": "系統參數-參數類別新增",
        "setParam17": "系統參數-參數類別修改",
    },
    "sqlLog": {
        "sqlLog01": "查詢日期",
        "sqlLog02": "使用者",
        "sqlLog03": "程式路徑",
        "sqlLog04": "日誌時間"
    },
    "speedEditor": {
        "button01": "公文編輯匯出Word",
        "button02": "公文編輯匯出PDF"
    }
}